module.exports = __webpack_public_path__ + "static/img/news.6c183875.jpg";